
import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import querystring from 'query-string';

import './Home.scss';
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IHomeProps {
}


const Home = (props: RouteComponentProps<IHomeProps>) => {
    const { history } = props;

    useEffect(() => {
        const qs: string = history.location.search;
        const options = querystring.parse(qs);
        if (options?.return_to || options?.redirect_to) {
            sessionStorage.setItem('return_to', (options?.return_to || options?.redirect_to) as string);
        } else {
            sessionStorage.removeItem('return_to');
        }
        history.push('/login');
    }, []);


    return (
        <div className='main'>Redirecting you to sign-in page...</div>
    );
};

export default Home;
